var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdministracion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3176 19.2005H20.6515V5.01804L21.4567 4.7841C21.5441 4.76196 21.6273 4.71642 21.7014 4.65015C21.7756 4.58388 21.8392 4.49823 21.8884 4.39825C21.9377 4.29827 21.9716 4.18598 21.9883 4.068C22.0049 3.95002 22.0038 3.82874 21.9852 3.71131C21.9666 3.59388 21.9308 3.48267 21.8798 3.38424C21.8289 3.28581 21.7639 3.20215 21.6886 3.13819C21.6133 3.07424 21.5294 3.03128 21.4416 3.01185C21.3539 2.99242 21.2642 2.99692 21.1777 3.02507L2.52624 8.42362C2.36556 8.47046 2.22337 8.59589 2.12703 8.77579C2.03068 8.95569 1.98699 9.17736 2.00435 9.39815C2.02171 9.61895 2.09889 9.82327 2.22106 9.97183C2.34322 10.1204 2.50174 10.2027 2.66612 10.2029C2.71343 10.2029 2.7606 10.1961 2.80684 10.1827L3.33225 10.0308V19.2005H2.66612C2.48946 19.2005 2.32003 19.2953 2.1951 19.464C2.07018 19.6328 2 19.8616 2 20.1002C2 20.3389 2.07018 20.5677 2.1951 20.7365C2.32003 20.9052 2.48946 21 2.66612 21H21.3176C21.4943 21 21.6637 20.9052 21.7886 20.7365C21.9136 20.5677 21.9837 20.3389 21.9837 20.1002C21.9837 19.8616 21.9136 19.6328 21.7886 19.464C21.6637 19.2953 21.4943 19.2005 21.3176 19.2005ZM16.6547 19.2005H7.329V17.401H16.6547V19.2005ZM16.6547 15.6014H7.329V13.8019H16.6547V15.6014Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministracion);
export default __webpack_public_path__ + "static/media/administracion.0fcbc0082a145b9069903cda1e50fa25.svg";
export { ForwardRef as ReactComponent };